import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
// 当设置 true 的时候该路由不会在侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
hidden: true // (默认 false)
//当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
redirect: 'noRedirect'
// 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
// 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
// 若你想不管路由下面的 children 声明的个数都显示你的根路由
// 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
alwaysShow: true
name: 'router-name' // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
这里的路由分为两种，constantRoutes 和 asyncRoutes。
constantRoutes： 代表那些不需要动态判断权限的路由，如登录页、404、等通用页面。
asyncRoutes： 代表那些需求动态判断权限并通过 addRoutes 动态添加的页面。
 **/

export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/agreement', component: () => import('@/views/agreement/index'), hidden: true},
  {path: '/print', component: () => import('@/views/print/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页', icon: 'home'}
    }]
  }
]

export const asyncRouterMap = [
  {
    path:'/bus',
    component: Layout,
    redirect: '/bus/admin',
    name: 'bus',
    meta: {title: '权限设置', icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/bus/admin/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/bus/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/bus/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/bus/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'bus-menu',
        name: 'bus-menu',
        component: () => import('@/views/bus/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'bus-addMenu',
        name: 'bus-addMenu',
        component: () => import('@/views/bus/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'bus-updateMenu',
        name: 'bus-updateMenu',
        component: () => import('@/views/bus/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'bus-resource',
        name: 'bus-resource',
        component: () => import('@/views/bus/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'}
      },
      {
        path: 'bus-resourceCategory',
        name: 'bus-resourceCategory',
        component: () => import('@/views/bus/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      },
      {
        path: 'bus-statistics',
        name: 'bus-statistics',
        component: () => import('@/views/bus/statistics/index'),
        meta: {title: '数据统计', icon: 'ums-resource'}
      },
    ]
  },{
    path:'/stu',
    component: Layout,
    redirect: '/stu/course',
    name: 'stu',
    meta: {title: '拙诚课程', icon: 'ums'},
    children: [
      {
        path: 'courseCategory',
        name: 'courseCategory',
        component: () => import('@/views/stu/courseCategory/index'),
        meta: {title: '课程分类', icon: 'ums-admin'}
      },
      {
        path: 'courseAdd',
        name: 'courseAdd',
        component: () => import('@/views/stu/course/edit'),
        meta: {title: '课程编辑', icon: 'ums-admin'}, 
        hidden: true
      },
      {
        path: 'course',
        name: 'course',
        component: () => import('@/views/stu/course/index'),
        meta: {title: '拙诚课程', icon: 'ums-admin'}
      },
      // {
      //   path: 'courseV1',
      //   name: 'courseV1',
      //   component: () => import('@/views/stu/course/indexV1'),
      //   meta: {title: '新拙诚课程', icon: 'ums-admin'}
      // },
      {
        path: 'courseItem',
        name: 'courseItem',
        component: () => import('@/views/stu/courseItem/index'),
        meta: {title: '单节课程', icon: 'ums-admin'}
      },
      {
        path: 'courseActivity',
        name: 'courseActivity',
        component: () => import('@/views/stu/courseActivity/index'),
        meta: {title: '精彩活动', icon: 'ums-admin'}
      },
      {
        path: 'module',
        name: 'module',
        component: () => import('@/views/my/module/index'),
        meta: {title: '课程开通', icon: 'ums-admin'}
      },
      {
        path: 'courseCoupon',
        name: 'courseCoupon',
        component: () => import('@/views/stu/courseCoupon/index'),
        meta: {title: '课程优惠券', icon: 'ums-admin'}
      }
    ]
  },{
    path:'/fro',
    component: Layout,
    redirect: '/fro/member',
    name: 'fro',
    meta: {title: '用户管理', icon: 'ums'},
    children: [
      {
        path: 'member',
        name: 'member',
        component: () => import('@/views/fro/member/index'),
        meta: {title: '用户管理', icon: 'ums-admin'}
      },
      {
        path: 'memberRole',
        name: 'memberRole',
        component: () => import('@/views/fro/memberRole/index'),
        meta: {title: '用户角色', icon: 'ums-admin'}
      },
      {
        path: 'memberQuery',
        name: 'memberQuery',
        component: () => import('@/views/fro/member/indexQuery'),
        meta: {title: '用户管理查', icon: 'ums-admin'}
      },
      {
        path: 'memberQuery/detail',
        name: 'memberQueryDetail',
        component: () => import('@/views/fro/member/detail'),
        meta: {title: '用户数据详情', icon: 'ums-admin'},
        hidden: true
      },
      {
        path: 'memberLog',
        name: 'memberLog',
        component: () => import('@/views/fro/memberLog/index'),
        meta: {title: '用户修改记录', icon: 'ums-admin'}
      },
      {
        path: 'agentWk',
        name: 'agentWk',
        component: () => import('@/views/fro/agent/index'),
        meta: {title: '历史用户', icon: 'ums-admin'}
      },
      {
        path: 'agentLog',
        name: 'agentLog',
        component: () => import('@/views/fro/agentLog/index'),
        meta: {title: '修改记录', icon: 'ums-admin'}
      },
      {
        path: 'memberLevel',
        name: 'memberLevel',
        component: () => import('@/views/fro/memberLevel/index'),
        meta: {title: '用户层级', icon: 'ums-admin'}
      },
      {
        path: 'memberSurvey',
        name: 'memberSurvey',
        component: () => import('@/views/fro/memberSurvey/index'),
        meta: {title: '用户盘课', icon: 'ums-admin'}
      },
    ]
  },

  {
    path:'/bra',
    component: Layout,
    redirect: '/bra/office',
    name: 'bra',
    meta: {title: '运营中心管理', icon: 'ums'},
    children: [
      {
        path: 'officeApply',
        name: 'officeApply',
        component: () => import('@/views/bra/officeApply/index'),
        meta: {title: '代理申请', icon: 'ums-admin'}
      },
      {
        path: 'officeApplyCourse',
        name: 'officeApplyCourse',
        component: () => import('@/views/bra/officeApplyCourse/index'),
        meta: {title: '代理课程', icon: 'ums-admin'}
      },
      {
        path: 'office',
        name: 'office',
        component: () => import('@/views/bra/office/index'),
        meta: {title: '运营中心管理', icon: 'ums-admin'}
      },
      {
        path: 'office-select',
        name: 'office-select',
        component: () => import('@/views/bra/office/index-select'),
        meta: {title: '运营中心查询', icon: 'ums-admin'}
      },
      {
        path: 'officeCapitalLog',
        name: 'officeCapitalLog',
        component: () => import('@/views/bra/officeCapitalLog/index'),
        meta: {title: '资产明细', icon: 'ums-admin'}
      },
      {
        path: 'officeLog',
        name: 'officeLog',
        component: () => import('@/views/bra/officeLog/index'),
        meta: {title: '修改记录', icon: 'ums-admin'}
      },
      // {
      //   path: 'officeScoreWeek',
      //   name: 'officeScoreWeek',
      //   component: () => import('@/views/bra/officeScoreWeek/index'),
      //   meta: {title: '周综合评分', icon: 'ums-admin'}
      // },
      {
        path: 'officeCapitalApply',
        name: 'officeCapitalApply',
        component: () => import('@/views/bra/officeCapitalApply/index'),
        meta: {title: '提现管理', icon: 'ums-admin'}
      },
      {
        path: 'courseCoupon',
        name: 'courseCoupon',
        component: () => import('@/views/bra/courseCoupon/index'),
        meta: {title: '我的优惠券', icon: 'ums-admin'}
      },
      {
        path: 'messageSystem',
        name: 'messageSystem',
        component: () => import('@/views/bra/messageSystem/index'),
        meta: {title: '系统消息', icon: 'ums-admin'}
      },
      {
        path: 'messageSystemEdit',
        name: 'messageSystemEdit',
        component: () => import('@/views/bra/messageSystem/edit'),
        meta: {title: '系统消息编辑', icon: 'ums-admin'},
        hidden: true
      },
      {
        path: 'officeApplyTemplate',
        name: 'officeApplyTemplate',
        component: () => import('@/views/bra/officeApplyTemplate/index'),
        meta: {title: '协议模板', icon: 'ums-admin'},
      },
      {
        path: 'officeGroupSettings',
        name: 'officeGroupSettings',
        component: () => import('@/views/bra/officeGroupSettings/index'),
        meta: {title: '群组设置', icon: 'ums-admin'},
      }
    ]
  },

  {
    path:'/brajf',
    component: Layout,
    redirect: '/brajf/officeScore',
    name: 'brajf',
    meta: {title: '运营中心积分', icon: 'ums'},
    children: [
      {
        path: 'officeScore',
        name: 'officeScore',
        component: () => import('@/views/bra/officeScore/index'),
        meta: {title: '积分管理', icon: 'ums-admin'}
      },
      {
        path: 'officeScoreDetails',
        name: 'officeScoreDetails',
        component: () => import('@/views/bra/officeScoreDetails/index'),
        meta: {title: '固定积分设置', icon: 'ums-admin'}
      },
      {
        path: 'officeScoreStandard',
        name: 'officeScoreStandard',
        component: () => import('@/views/bra/officeScoreStandard/index'),
        meta: {title: '积分标准', icon: 'ums-admin'}
      },
      {
        path: 'officeScoreMonth',
        name: 'officeScoreMonth',
        component: () => import('@/views/bra/officeScoreMonth/index'),
        meta: {title: '月度积分', icon: 'ums-admin'}
      },
      {
        path: 'officeScoreLog',
        name: 'officeScoreLog',
        component: () => import('@/views/bra/officeScoreLog/index'),
        meta: {title: '积分申请', icon: 'ums-admin'}
      },
      {
        path: 'officeScoreRecord',
        name: 'officeScoreRecord',
        component: () => import('@/views/bra/officeScoreRecord/index'),
        meta: {title: '积分记录', icon: 'ums-admin'}
      },
      {
        path: 'officeScoreLogEdit',
        name: 'officeScoreLogEdit',
        component: () => import('@/views/bra/officeScoreLog/edit'),
        meta: {title: '申请积分', icon: 'ums-admin'},
        hidden: true
      },
      {
        path: 'officeScoreRanking',
        name: 'officeScoreRanking',
        component: () => import('@/views/bra/officeScore/detail'),
        meta: {title: '积分排名', icon: 'ums-admin'},
        hidden: true
      }
    ]
  },
  {
    path:'/product',
    component: Layout,
    redirect: '/product/productSign',
    name: 'product',
    meta: {title: '报课中心', icon: 'ums'},
    children: [
      {
        path: 'productType',
        name: 'productType',
        component: () => import('@/views/cla/productType/index'),
        meta: {title: '课程产品', icon: 'ums-admin'}
      },{
        path: 'productSign',
        name: 'productSign',
        component: () => import('@/views/cla/productSign/index'),
        meta: {title: '订单管理', icon: 'ums-admin'}
      },
      {
        path: 'productOrder',
        name: 'productOrder',
        component: () => import('@/views/cla/productOrder/index'),
        meta: {title: '流水管理', icon: 'ums-admin'}
      },
      {
        path: 'productOrdersearch',
        name: 'productOrdersearch',
        component: () => import('@/views/cla/productOrder/index-search'),
        meta: {title: '流水管理查', icon: 'ums-admin'}
      },
      {
        path: 'productFlow',
        name: 'productFlow',
        component: () => import('@/views/cla/productFlow/index'),
        meta: {title: '汇付流水', icon: 'ums-admin'}
      },
      {
        path: 'productConsign',
        name: 'productConsign',
        component: () => import('@/views/cla/productConsign/index'),
        meta: {title: '交付管理', icon: 'ums-admin'}
      },
      {
        path: 'productConsign/charts',
        name: 'productConsignCharts',
        component: () => import('@/views/cla/productConsign/charts'),
        meta: {title: '交付管理数据看板', icon: 'ums-admin'},
        hidden: true
      }
    ]
  },
  {
    path:'/sale',
    component: Layout,
    redirect: '/sale/agent',
    name: 'sale',
    meta: {title: '销售管理', icon: 'ums'},
    children: [
       {
        path: 'agent',
        name: 'agent',
        component: () => import('@/views/sale/agent/index'),
        meta: {title: '销售管理', icon: 'ums-admin'}
      },
      {
        path: 'agentSelect',
        name: 'agentSelect',
        component: () => import('@/views/sale/agent/index-select'),
        meta: {title: '销售管理查', icon: 'ums-admin'}
      },
      {
        path: 'agentCapitalLog',
        name: 'agentCapitalLog',
        component: () => import('@/views/sale/agentCapitalLog/index'),
        meta: {title: '销售资产明细', icon: 'ums-admin'}
      },
      {
        path: 'saleAgentLog',
        name: 'saleAgentLog',
        component: () => import('@/views/sale/agentLog/index'),
        meta: {title: '销售修改记录', icon: 'ums-admin'}
      },
      {
        path: 'couponCark',
        name: 'couponCark',
        component: () => import('@/views/sale/couponCark/index'),
        meta: {title: '永久会员卡', icon: 'ums-admin'}
      },
      {
        path: 'agentCapitalApply',
        name: 'agentCapitalApply',
        component: () => import('@/views/sale/agentCapitalApply/index'),
        meta: {title: '提现管理', icon: 'ums-admin'}
      }
    ]
  },
  {
    path:'/shop',
    component: Layout,
    redirect: '/shop/item',
    name: 'shop',
    meta: {title: '商城管理', icon: 'ums'},
    children: [
      {
        path: 'item',
        name: 'item',
        component: () => import('@/views/shop/item/index'),
        meta: {title: '商品管理', icon: 'ums-admin'}
      },
      {
        path: 'itemSku',
        name: 'itemSku',
        component: () => import('@/views/shop/itemSku/index'),
        meta: {title: '商品规格', icon: 'ums-admin'}
      },
      {
        path: 'itemOrder',
        name: 'itemOrder',
        component: () => import('@/views/shop/itemOrder/index'),
        meta: {title: '商品订单', icon: 'ums-admin'}
      }
    ]
  },
  {
    path:'/act',
    component: Layout,
    redirect: '/act/evaluate',
    name: 'act',
    meta: {title: '活动管理', icon: 'ums'},
    children: [
      {
        path: 'mentor',
        name: 'mentor',
        component: () => import('@/views/act/mentor/index'),
        meta: {title: '导师管理', icon: 'ums-admin'}
      },
      {
        path: 'evaluate',
        name: 'evaluate',
        component: () => import('@/views/act/evaluate/index'),
        meta: {title: '评价管理', icon: 'ums-admin'}
      },
      {
        path: 'evaluateLog',
        name: 'evaluateLog',
        component: () => import('@/views/act/evaluateLog/index'),
        meta: {title: '评价记录', icon: 'ums-admin'}
      }
    ]
  },
  {
    path:'/topic',
    component: Layout,
    name: 'topic',
    meta: {title: '话题管理', icon: 'ums'},
    children: [
      {
        path: 'circle',
        name: 'circle',
        component: () => import('@/views/topic/circle/index'),
        meta: {title: '圈子列表', icon: 'ums-admin'}
      },
      {
        path: 'group',
        name: 'group',
        component: () => import('@/views/topic/group/index'),
        meta: {title: '话题列表', icon: 'ums-admin'}
      },
      {
        path: 'system',
        name: 'system',
        component: () => import('@/views/topic/system/index'),
        meta: {title: '系统弹幕', icon: 'ums-admin'}
      }
    ]
  },
  {
    path:'/order',
    component: Layout,
    redirect: '/order/memberOrder',
    name: 'order',
    meta: {title: '订单管理', icon: 'ums'},
    children: [
      {
        path: 'memberOrder',
        name: 'memberOrder',
        component: () => import('@/views/fro/memberOrder/index'),
        meta: {title: '订单管理', icon: 'ums-admin'}
      },
      {
        path: 'orderRefund',
        name: 'orderRefund',
        component: () => import('@/views/com/orderRefund/index'),
        meta: {title: '退款管理', icon: 'ums-admin'}
      },
    ]
  },
  {
    path:'/cla',
    component: Layout,
    redirect: '/cla/claCourse',
    name: 'cla',
    meta: {title: '线下课程', icon: 'ums'},
    children: [
      {
        path: 'courseSeries',
        name: 'courseSeries',
        component: () => import('@/views/cla/courseSeries/index'),
        meta: {title: '系列课程', icon: 'ums-admin'}
      },
      {
        path: 'claCourse',
        name: 'claCourse',
        component: () => import('@/views/cla/course/index'),
        meta: {title: '线下课程', icon: 'ums-admin'}
      },
      {
        path: 'claCourseLog',
        name: 'claCourseLog',
        component: () => import('@/views/cla/courseLog/index'),
        meta: {title: '线下课程修改', icon: 'ums-admin'}
      },
      {
        path: 'courseEdit',
        name: 'courseEdit',
        component: () => import('@/views/cla/course/edit'),
        meta: {title: '编辑线下课程', icon: 'ums-admin'},
        hidden: true
      },
      {
        path: 'claOrder',
        name: 'claOrder',
        component: () => import('@/views/cla/order/index'),
        meta: {title: '报名课程', icon: 'ums-admin'}
      },
      {
        path: 'claOrderZhihui',
        name: 'claOrderZhihui',
        component: () => import('@/views/cla/order/indexZhihui'),
        meta: {title: '少年报名课程', icon: 'ums-admin'},
        hidden: true
      },
      {
        path: 'claOrderData',
        name: 'claOrderData',
        component: () => import('@/views/cla/claOrderData/index'),
        meta: {title: '数据看板', icon: 'ums-admin'},
        hidden: true
      },
      {
        path: 'customersEcharts',
        name: 'customersEcharts',
        component: () => import('@/views/cla/claOrderData/customersEcharts'),
        meta: {title: '盘客看板', icon: 'ums-admin'},
        hidden: true
      },
      {
        path: 'claOrderGroup',
        name: 'claOrderGroup',
        component: () => import('@/views/cla/claOrderGroup/index'),
        meta: {title: '报名分组', icon: 'ums-admin'},
        hidden: true
      },
      {
        path: 'claOrderQuery',
        name: 'claOrderQuery',
        component: () => import('@/views/cla/order/indexQuery'),
        meta: {title: '报名课程查', icon: 'ums-admin'}
      },
      {
        path: 'claOrderLog',
        name: 'claOrderLog',
        component: () => import('@/views/cla/orderLog/index'),
        meta: {title: '报名修改', icon: 'ums-admin'}
      }
    ]
  },
  {
    path:'/msg',
    component: Layout,
    name: 'msg',
    meta: {title: '消息管理', icon: 'ums'},
    children: [
      {
        path: 'template',
        name: 'template',
        component: () => import('@/views/msg/template/index'),
        meta: {title: '消息模版', icon: 'ums-admin'}
      },
      {
        path: 'pushLog',
        name: 'pushLog',
        component: () => import('@/views/msg/pushLog/index'),
        meta: {title: '推送日志', icon: 'ums-admin'}
      },
      {
        path: 'subscribe',
        name: 'subscribe',
        component: () => import('@/views/msg/subscribe/index'),
        meta: {title: '消息订阅', icon: 'ums-admin'}
      }
    ]
  },
  {
    path:'/com',
    component: Layout,
    redirect: '/fro/advertise',
    name: 'com',
    meta: {title: '营销管理', icon: 'ums'},
    children: [
      {
        path: 'advertise',
        name: 'advertise',
        component: () => import('@/views/com/advertise/index'),
        meta: {title: 'Banner管理', icon: 'ums-admin'}
      },
      {
        path: 'advertiseEdit',
        name: 'advertiseEdit',
        component: () => import('@/views/com/advertise/edit'),
        meta: {title: 'Banner编辑', icon: 'ums-admin'},
        hidden: true
      },
      {
        path: 'advise',
        name: 'advise',
        component: () => import('@/views/com/advise/index'),
        meta: {title: '意见反馈', icon: 'ums-admin'}
      },
      {
        path: 'config',
        name: 'config',
        component: () => import('@/views/com/config/index'),
        meta: {title: '公共属性', icon: 'ums-admin'}
      },
      {
        path: 'shareXcx',
        name: 'shareXcx',
        component: () => import('@/views/com/config/shareXcx'),
        meta: {title: '小程序分享', icon: 'ums-admin'}
      },
      {
        path: 'dictionary',
        name: 'dictionary',
        component: () => import('@/views/com/dictionary/index'),
        meta: {title: '字典属性', icon: 'ums-admin'}
      },
      {
        path: 'appVersion',
        name: 'appVersion',
        component: () => import('@/views/com/appVersion/index'),
        meta: {title: 'app版本', icon: 'ums-admin'}
      },
      {
        path: 'sharingMaterial',
        name: 'sharingMaterial',
        component: () => import('@/views/com/sharingMaterial/index'),
        meta: {title: '分享素材', icon: 'ums-admin'}
      },
      {
        path: 'checkin',
        name: 'checkin',
        component: () => import('@/views/com/checkin/index'),
        meta: {title: '日签签到', icon: 'ums-admin'}
      },
      {
        path: 'materialType',
        name: 'materialType',
        component: () => import('@/views/sale/materialType/index'),
        meta: {title: '必备技能分类', icon: 'ums-admin'}
      },
      {
        path: 'material',
        name: 'material',
        component: () => import('@/views/sale/material/index'),
        meta: {title: '必备技能', icon: 'ums-admin'}
      },
      {
        path: 'comment',
        name: 'comment',
        component: () => import('@/views/my/comment/index'),
        meta: {title: '用户评论', icon: 'ums-admin'}
      },
      {
        path: 'reply',
        name: 'commentReply',
        component: () => import('@/views/my/comment/reply'),
        meta: {title: '评论回复', icon: 'ums-admin'}
      },
      {
        path: 'auditLog',
        name: 'auditLog',
        component: () => import('@/views/com/auditLog/index'),
        meta: {title: '审核日志', icon: 'ums-admin'}
      }
    ]
  },
   {
    path:'/meditation',
    component: Layout,
    name: 'meditation',
    meta: {title: '冥想管理', icon: 'ums'},
    children: [
      {
        path: 'type',
        name: 'type',
        component: () => import('@/views/meditation/type/index'),
        meta: {title: '类型列表', icon: 'ums-admin'}
      },
      {
        path: 'list',
        name: 'list',
        component: () => import('@/views/meditation/list/index'),
        meta: {title: '冥想列表', icon: 'ums-admin'}
      },
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js